import { ref, toRefs } from 'vue';
import { defineStore } from 'pinia';
import useStoreGetters from './getters';
import useUiStoreActions from './actions';
import { LanguageCodes } from '@/shared/constants';
import { IApplicationSettings, IUIState, UserInformation } from './models';

export const useUiStore = defineStore('ui', () => {
  const state = ref(<IUIState>{
    isDrawerVisible: false,
    isMainMenuCollapsed: false,
    useContainer: false,
    isChatFullWidth: false,
    userPreferences: [],
    appSettings: {
      lang: LanguageCodes.en,
    } as IApplicationSettings,
    sessionUserInfo: null as UserInformation | null,
    userAvatarsCache: [],
    sentenceList: [],
  });

  return {
    ...toRefs(state.value),
    ...useStoreGetters(state),
    ...useUiStoreActions(state),
  };
});
